// extracted by css-extract-rspack-plugin
export default {"box":"Tags__box--pMwoY"};